import { FC } from 'react';
import { LoaderIcon } from 'assets/img';
import './style.scss';

interface ILoaderProps {
  size?: number;
}

export const Loader: FC<ILoaderProps> = (props) => {
  const { size = 50 } = props;

  return (
    <div className="block-loader" style={{ width: `${size}px`, height: `${size}px` }}>
      <LoaderIcon/>
    </div>
  );
};

export const LoaderFullScreen: FC = () => (
  <div className="block-loader-full-screen">
    <Loader size={120}/>
  </div>
);

export const LoaderScreen: FC = () => (
  <div className="block-loader-screen">
    <Loader size={120}/>
  </div>
);
